<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row">
    <div class="col-md-12">
        <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
            <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                <span style="float:left">Edit my profile</span>
            </h6>
        </div>
        <div class="col-xl-12 block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
            <div class="col-md-12 col-sm-12 ">

                <div class="row small-section-content" style="margin-bottom:20px">
                    <div class="col-xl-12 text-center empty no-padding">
                        <p style="text-align: left;padding-top: 10px;">
                            Edit your profile
                        </p>
                    </div>
                </div>


                <mat-stepper [linear]="isLinear" #stepper>
                    <mat-step [stepControl]="firstFormGroup" label="Personal information">


                        <div class="row small-section-content" style="margin-bottom:20px">
                            <div class="col-xl-12 text-center empty no-padding">
                                <p style="text-align: left;padding-top: 10px;">
                                    Personal information description
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding">
                                <div class="form-floating" style="margin-right:5px">
                                    <input [(ngModel)]="userData.eMail" disabled type="text" class="form-control" id="floatingInputValueSubject">
                                    <label for="floatingInputValueSubject">Email Address</label>
                                </div>
                            </div>
                            <div class="form-group col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-top: 5px;margin-bottom:20px">
                                <a (click)="openRequest()" style="color:darkblue; cursor:pointer;">click here to request changing your email address</a>
                            </div>


                        </div>

                        <div class="row">
                            <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom:20px">
                                <div class="form-floating" style="margin-right: 5px;">
                                    <input [(ngModel)]="userData.firstName" type="text" class="form-control" id="floatingInputValueSubject">
                                    <label for="floatingInputValueSubject">First name</label>
                                </div>
                            </div>
                            <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom: 20px">
                                <div class="form-floating" style="margin-left: 5px; ">
                                    <input [(ngModel)]="userData.lastName" type="text" class="form-control" id="floatingInputValueSubject">
                                    <label for="floatingInputValueSubject">Last name</label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom: 20px">
                                <label class="col-form-label" style="font-size: 12px; color: #818181; position: absolute; top: 6px; left: 14px; ">Mobile Number</label>
                                <div id="edit_phone" class="form-group">
                                    <form class="example-form" style=" padding: 0px; margin-top: 7px; margin-right: 5px;" [formGroup]="mobileLoginForm">
                                        <ngx-mat-intl-tel-input [disabled]="phoneDisabled" style="height:58px" class="form-control" [preferredCountries]="['ae', 'sa', 'jo']"
                                                                [enablePlaceholder]="true"
                                                                [enableSearch]="true"
                                                                name="phone" formControlName="phone"
                                                                describedBy="phoneInput"></ngx-mat-intl-tel-input>
                                    </form>
                                </div>
                            </div>
                            <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom:20px">
                                <div class="form-floating" style="margin-left: 5px;">
                                    <select (change)="genderChangeValue($event)" class="form-select" id="floatingSelect" aria-label="Floating label select example">
                                        <option value="">
                                            Prefer not to specify
                                        </option>
                                        <option value="Male">
                                            Male
                                        </option>
                                        <option value="Female">
                                            Female
                                        </option>
                                    </select>
                                    <label for="floatingSelect">Gender</label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                                <div class="form-floating">
                                    <input [(ngModel)]="userData.education" type="text" class="form-control" id="floatingInputValueSubject">
                                    <label for="floatingInputValueSubject">Your education</label>
                                </div>
                            </div>
                        </div>
                        
                        <div id="countrydiv" class="row">
                            <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom:20px">
                                <div class="form-floating" style="margin-right: 5px;">
                                    <select (change)="nationalityChangeValue($event)" class="form-select" id="floatingSelect" aria-label="Floating label select example">
                                        <option value="0">
                                            select your nationality
                                        </option>
                                        <option *ngFor="let option of nationalityList" [value]="option.name" [selected]="option.selected">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <label for="floatingSelect">Nationality</label>
                                </div>
                            </div>
                            <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom:20px">
                                <div class="form-floating" style="margin-left: 5px;">
                                    <select (change)="countryChangeValue($event)" class="form-select" id="floatingSelect" aria-label="Floating label select example">
                                        <option value="0">
                                            select your country of residence
                                        </option>
                                        <option *ngFor="let option of countryOfResidenceList" [value]="option.name" [selected]="option.selected">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <label for="floatingSelect">Country of residence</label>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom:20px">
                                <div class="form-floating" style="margin-right: 5px;">
                                    <input [(ngModel)]="userData.fblink" type="text" class="form-control" id="floatingInputValueSubject">
                                    <label for="floatingInputValueSubject">Your facebook URL</label>
                                </div>
                            </div>
                            <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom: 20px">
                                <div class="form-floating" style="margin-left: 5px; ">
                                    <input [(ngModel)]="userData.linkedin" type="text" class="form-control" id="floatingInputValueSubject">
                                    <label for="floatingInputValueSubject">Your linkedin URL</label>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group col-md-6 col-sm-6 col-xs-6  no-padding" style="margin-bottom:20px">
                                <div class="form-floating" style="margin-right: 5px;">
                                    <input [(ngModel)]="userData.twitter" type="text" class="form-control" id="floatingInputValueSubject">
                                    <label for="floatingInputValueSubject">Your twitter URL</label>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom:20px">

                                <div class="form-floating">
                                    <!--<textarea style="height:150px" class="form-control" placeholder="Leave your description here..." id="floatingTextareaDescription"></textarea>-->
                                    <quill-editor [(ngModel)]="userData.summary" [styles]="{height: '250px'}" placeholder="Your profile summary here..."></quill-editor>
                                    <!--<label for="floatingTextareaDescription">Discussion Details</label>-->
                                </div>

                            </div>
                        </div>
                       



                        <div class="row">
                            <div class="col-xl-6"></div>
                            <div class="col-xl-6 text-right">
                                <button style="float: right;" class="right" mat-button matStepperNext>Next</button>
                            </div>

                        </div>

                    </mat-step>
                    <mat-step [stepControl]="secondFormGroup" label="Organization information">

                        <div class="row small-section-content" style="margin-bottom:20px">
                            <div class="col-xl-12 text-center empty no-padding">
                                <p style="text-align: left;padding-top: 10px;">
                                    organization information description
                                </p>
                            </div>
                        </div>

                        <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding">
                            <div class="form-floating">
                                <input [(ngModel)]="userData.portalAccount.name" disabled type="text" class="form-control" id="floatingInputValueSubject">
                                <label for="floatingInputValueSubject">Company</label>
                            </div>
                        </div>
                        <div class="form-group col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-top: 5px;margin-bottom:20px">
                            <a (click)="openRequest()" style="color:darkblue; cursor:pointer;">click here to request changing your organization</a>
                        </div>
                        <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                            <div class="form-floating">
                                <input [(ngModel)]="userData.title" type="text" class="form-control" id="floatingInputValueSubject">
                                <label for="floatingInputValueSubject">Job title</label>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xl-6 text-left">
                                <button mat-button matStepperPrevious>Back</button>
                            </div>
                            <div class="col-xl-6 text-right">
                                <button style="float: right;" mat-button matStepperNext>Next</button>
                            </div>

                        </div>

                    </mat-step>

                    <mat-step [stepControl]="secondFormGroup" label="Profile information">
                        <div class="row small-section-content" style="margin-bottom:20px">
                            <div class="col-xl-12 text-center empty no-padding">
                                <p style="text-align: left;padding-top: 10px;">
                                    Change your profile privacy like, who can see your personal information
                                </p>
                            </div>
                        </div>
                        <section class="example-section" [formGroup]="privacy">
                            <mat-checkbox formControlName="allowSearch" style="margin-bottom:10px" class="example-margin">Allow others to find me</mat-checkbox><br />
                            <mat-checkbox formControlName="allowEmailAddress" style="margin-bottom:10px" class="example-margin">Allow others to see my email address</mat-checkbox><br />
                            <mat-checkbox formControlName="allowMobileNumber" style="margin-bottom:10px" class="example-margin">Allow others to see my mobile number</mat-checkbox><br />
                            <mat-checkbox formControlName="allowSocialMediaLinks" style="margin-bottom:10px" class="example-margin">Allow others to see my social media links</mat-checkbox>
                        </section>

                        <div class="row">
                            <div class="col-xl-6 text-left">
                                <button mat-button matStepperPrevious>Back</button>
                            </div>
                            <div class="col-xl-6 text-right">
                                <button style="float: right;" (click)="save()" class="btn mygistec-main-btn">Save</button>
                            </div>

                        </div>

                    </mat-step>
                </mat-stepper>

            </div>
        </div>

    </div>
</div>
